import { ColType, PaginatedTable } from 'chakra-paginated-table'
import React, { useMemo, useState } from 'react'
import { commonPaginationProps, ISchema, TABLE_PAGE_SIZE, TErrorState } from '../definitions'
import { Text, Tooltip } from '@chakra-ui/react'
interface IProps {
  errorState: TErrorState
}
function ErrorTable({ errorState }: IProps) {
  const [page, setpage] = useState(1)
  const dataSource = useMemo(
    () =>
      typeof errorState === 'string'
        ? errorState
        : errorState.map(
            (eachError) =>
              eachError.currentRow?.data || {
                firstName: '',
                language: '',
                lineNo: '',
                country: '',
                email: '',
                lastName: '',
                leadStatus: '',
                phone: '',
              },
          ),
    [errorState],
  )

  if (typeof dataSource === 'string')
    return (
      <div>
        {dataSource.split('...').map((eachLine, i) => (
          <div key={i}>{eachLine}</div>
        ))}
      </div>
    )

  const cols: ColType<ISchema>[] = Object.keys(dataSource[0] || {}).map((eachCol) => ({
    key: eachCol,
    title: eachCol,
    align: 'center',
    dataKey: eachCol as keyof ISchema,
    render(value, _, index) {
      if (typeof errorState === 'string') return <></>
      const recordIndex = (page - 1) * TABLE_PAGE_SIZE + index!
      const val =
        typeof value === 'string' && !value.trim() ? (
          <Text style={errorStyleProps}>N/A</Text>
        ) : (
          value || <Text style={errorStyleProps}>N/A</Text>
        )
      return eachCol === 'lineNo' ? (
        <strong>{errorState[recordIndex].currentRow?.index! + 2}</strong>
      ) : Object.keys(errorState[recordIndex].invalidFields).includes(eachCol) ? (
        <Tooltip
          bgColor="blue.400"
          placement="left"
          padding="0.5rem"
          cursor="pointer"
          label={errorState[recordIndex].invalidFields[eachCol]}
        >
          <Text style={errorStyleProps}>{val || 'N/A'}</Text>
        </Tooltip>
      ) : (
        val
      )
    },
  }))

  return (
    <PaginatedTable
      dataSource={dataSource}
      rowKey={(_, i) => i}
      columns={cols}
      pagination={{
        page,
        pageSize: TABLE_PAGE_SIZE,
        total: dataSource.length,
        onchange(newPage) {
          setpage(newPage)
        },
        ...commonPaginationProps,
      }}
    />
  )
}

const errorStyleProps: React.CSSProperties = { color: 'red' }
export default ErrorTable
